module.exports = __webpack_public_path__ + "img/4d4c0563e9944b14b228d571460ff71e.661c4bc1.jpg";